module.exports = __webpack_public_path__ + "static/img/honor_5.47f5fee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/honor_5.jpg
// module id = Kbr1
// module chunks = 0